var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    width: 24,
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "#272726",
    strokeLinejoin: "round",
    className: "ticket_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 2h36v44H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 26l4 4 12-12"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48dGl0bGU+ZmlsZSBjaGVjazwvdGl0bGU+PGcgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzI3MjcyNiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgY2xhc3M9Im5jLWljb24td3JhcHBlciI+PHJlY3QgeD0iNiIgeT0iMiIgd2lkdGg9IjM2IiBoZWlnaHQ9IjQ0Ij48L3JlY3Q+IDxwb2x5bGluZSBwb2ludHM9IiAxNiwyNiAyMCwzMCAzMiwxOCAiIHN0cm9rZT0iIzI3MjcyNiI+PC9wb2x5bGluZT48L2c+PC9zdmc+";
export { SvgTicket as ReactComponent };